// @ts-ignore
const MainRoutes = {
    path: '/main',
    meta: {
        requiresAuth: true
    },
    redirect: '/main',
    component: () => import('@/layouts/full/FullLayout.vue'),
    children: [
        {
            name: 'Profile',
            path: '/apps/user/profile',
            component: () => import('@/views/apps/user/profile/Profile.vue'),
            meta: { requiresAuth: true },
        },
        {
            name: 'Starter',
            path: '/',
            component: () => import('@/views/StarterPage.vue')
        },
        {
            name: 'Contract Combination',
            path: '/apps/contractcombination/:supplierId/:cc_id?',
            component: () => import('@/views/apps/contractcombination/ContractCombination.vue'),
            props: true
        },
        {
            name: 'Contract Combination Details',
            path: '/apps/contractcombinationdetail/:cc_id/:supplierId',
            component: () => import('@/views/apps/contractcombinationsummary/ContractCombinationSummary.vue'),
            props: true
        },
        {
            name: 'Suppliers',
            path: '/apps/supplier',
            component: () => import('@/views/apps/supplier/Supplier.vue')
        },
        {
            name: 'Meter Reading',
            path: '/apps/meter',
            component: () => import('@/views/apps/meter/Meter.vue')
        },
        {
            name: 'Solar Table',
            path: '/apps/solar',
            component: () => import('@/views/apps/solar/Solar.vue')
        },
        {
            name: 'Contract Tariffs',
            path: '/apps/tariffs/:id/:cc_id',
            component: () => import('@/views/apps/tariff/Tariff.vue'),
            props: true
        },
        {
            name: 'Reading Chart',
            path: '/apps/readingchart',
            component: () => import('@/components/ui-components/charts/ReadingChart.vue'),
            props: true
        },
        {
            name: 'Pie Chart',
            path: '/apps/piechart/:combinationId',
            component: () => import('@/components/ui-components/charts/CostPieChart.vue'),
            props: true
        },
        {
            name: 'Reading Chart Month',
            path: '/apps/reports/month',
            component: () => import('@/views/apps/contractcombination/Month.vue'),
            props: true
        },
        {
            name: 'Energy Usage',
            path: '/apps/data-mining/usage',
            component: () => import('@/views/apps/data-mining/EnergyUsage.vue'),
        },
        {
            name: 'Solar Output',
            path: '/apps/data-mining/solar',
            component: () => import('@/views/apps/data-mining/SolarOutput.vue'),
        },
        {
            name: 'Combined Views',
            path: '/apps/data-mining/overview',
            component: () => import('@/views/apps/data-mining/CombinedView.vue'),
        }
    ]
};

export default MainRoutes;
